<shared-box class="tile-for-reward" [contentHorizontalPaddings]="false" [contentVerticalPaddings]="false"
    [ngClass]="{'-loaded': reward && !loading}" (click)="handleClick($event)">

    <div class="tile-for-reward__inner">

        <div class="tile-for-reward__bd">

            <div class="tile-for-reward__content">
                <shared-header [ellipsis]="true" type="5" marginTop="none" marginBottom="xs"
                    [loading]="!reward || loading">
                    {{reward?.OnlineName || reward?.POSDisplay}}
                </shared-header>

                <div class="tile-for-reward__desc">
                    <ng-container *ngIf="reward">
                        Valid until {{reward?.ExpiryDate | date: 'dd/MM/yyyy'}}
                    </ng-container>
                    <shared-loader-for-placeholder *ngIf="!reward" class="tile-for-reward__loader -for-description">
                    </shared-loader-for-placeholder>

                </div>
            </div>


            <shared-icon-btn [size]="btnSize" [emphasis]="true" class="tile-for-reward__actions" *ngIf="reward">
                VIEW REWARD
            </shared-icon-btn>

        </div>

        <shared-thumb-for-reward class="tile-for-reward__thumb" [src]="(image$ | async)?.data"
            [loading]="loading || !reward || (image$ | async)?.isDownloading === true">
        </shared-thumb-for-reward>

    </div>

</shared-box>







<!-- <shared-header type="3" class="tile-for-reward__hd" [loading]="programItem?.isLoading || !programItem"
        marginTop="none" marginBottom="sm" [inverted]="true">
        {{programItem?.program?.ProductQauantityToIssue || 0}} Free {{programItem?.codeName}} beverage
    </shared-header>

    <div class="tile-for-reward__desc">
        <ng-container *ngIf="programItem?.isLoading || !programItem">

            <shared-loader-for-placeholder class="tile-for-reward__loader -for-description">
            </shared-loader-for-placeholder>
            <shared-loader-for-placeholder class="tile-for-reward__loader -for-description">
            </shared-loader-for-placeholder>
        </ng-container>

        <ng-container *ngIf="programItem && !programItem.isLoading">
            Woo hoo you have a free {{programItem?.codeName}} beverage.<br />
            Scan your card in store to redeem.
        </ng-container>
    </div> -->